import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { clearFavorites } from "../../../slices/wishlist";

const WishlistHeader = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const dispatch = useDispatch();

  function toggleMenu() {
    setOpenMenu(!openMenu);
  }

  function handleClearList() {
    dispatch(clearFavorites());
    toggleMenu();
  }

  return (
    <div className="w-full flex items-center mb-[21px] pt-[45px] px-[50px]">
      <h2 className="text-xl font-medium leading-[30px] text-[#434655] grow">
        My Wishlist
      </h2>
      <div className="relative z-20">
        <button className="text-[#434655]" onClick={toggleMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
            />
          </svg>
        </button>
        {openMenu && (
          <div
            className="absolute top-2 right-8 w-40 px-5 py-8 bg-[#f8f8f8] modal_ticket"
            style={{
              boxShadow: "0 2px 10px 0 rgb(0 0 0 / 10%)",
            }}
          >
            <button
              className="flex items-center text-secondary-500 py-[10px]"
              onClick={handleClearList}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path
                  fillRule="evenodd"
                  d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="ml-2 text-sm font-medium leading-[20px]">
                Clear List
              </span>
            </button>
          </div>
        )}
      </div>
      {openMenu && (
        <div
          className="absolute top-0 left-0 z-10 w-screen h-screen bg-black/20"
          onClick={toggleMenu}
        />
      )}
    </div>
  );
};

export default WishlistHeader;
